import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, animate, keyframes, style } from '@angular/animations';
import * as kf from 'src/app/core/animations/keyframes';

@Component({
  selector: 'gio-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('animation1', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition('* => in',
        animate('0.6s',
          keyframes([
            style({ 'margin-left': '-200%', offset: 0 }),
            style({ 'margin-left': '0px', offset: 1 }),
          ])
        ))
    ]),
    trigger('animation2', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition('* => in', animate('0.8s',
        keyframes([
          style({ 'margin-left': '-200%', offset: 0 }),
          style({ 'margin-left': '0px', offset: 1 }),
        ])
      ))
    ]),
    trigger('animation3', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition('* => in', animate('1s',
        keyframes([
          style({ 'margin-left': '-200%', offset: 0 }),
          style({ 'margin-left': '0px', offset: 1 }),
        ])
      ))
    ])
  ]
})
export class LogoComponent implements OnInit {

  @Input() src: 'text' | 'img' = 'text';

  @Input() animate = true;

  _animate = 'none';

  constructor() { }

  ngOnInit(): void {
    if (this.animate) {
      this._animate = 'in';
    }
  }

}
